module.exports = __webpack_public_path__ + "static/gallery20-512baf65242c3c3c450335eb888c9cc2.png";